import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import ExpertiseCarousel from './components/ExpertiseCarousel';
import Solutions from './components/Solutions';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App bg-white text-gray-800 font-sans relative min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <ExpertiseCarousel />
        <Solutions />
        <About />
        <Contact />
      </main>
      <Footer />

      {/* Floating Contact Us Button */}
      <button 
        onClick={scrollToContact}
        className="fixed bottom-6 left-6 bg-primary text-white p-4 rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300 ease-in-out z-40 group"
        aria-label="Scroll to Contact Section"
      >
        {/* Simple Mail Icon - Consider using a library like react-icons */}
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        {/* Tooltip text (optional, appears on hover) */}
        {/* <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2">Contact Us</span> */}
      </button>
    </div>
  );
}

export default App; 